import JSZip from "jszip";
import { saveAs } from "file-saver";
import { captureImage } from "./captureImage";

export const downloadZip = async (materialRefs, meetupNo, format = "png") => {
  const zip = new JSZip();
  const ext = format === "jpg" ? "jpg" : "png";

  for (const { name, ref, width, height } of materialRefs) {
    if (!ref.current) continue;

    try {
      const dataUrl = await captureImage(ref.current, format, { width, height });
      const base64 = dataUrl.split(",")[1];
      zip.file(`${name}.${ext}`, base64, { base64: true });
    } catch (error) {
      console.error(`Failed to capture ${name}:`, error);
    }
  }

  const blob = await zip.generateAsync({ type: "blob" });
  saveAs(blob, `meetup-${meetupNo}-promo-materials.zip`);
};
